var colorHelper = new THREE.Color();

/**
 * Set geometry vertex colors, allows for geometry merging using one material
 * while retaining colors.
 */
AFRAME.registerComponent('vertex-colors-buffer', {
  schema: {
    baseColor: {type: 'color'},
    itemSize: {default: 3}
  },

  update: function (oldData) {
    var colors;
    var data = this.data;
    var i;
    var el = this.el;
    var geometry;
    var mesh;
    var self = this;

    mesh = this.el.getObject3D('mesh');

    if (!mesh || !mesh.geometry) {
      el.addEventListener('object3dset', function reUpdate (evt) {
        if (evt.detail.type !== 'mesh') { return; }
        el.removeEventListener('object3dset', reUpdate);
        self.update(oldData);
      });
      return;
    }

    geometry = mesh.geometry;

    // Empty geometry.
    if (!geometry.attributes.position) {
      console.warn('Geometry has no vertices', el);
      return;
    }

    if (!geometry.attributes.color) {
      geometry.setAttribute('color',
        new THREE.BufferAttribute(
          new Float32Array(geometry.attributes.position.array.length), 3
        )
      );
    }

    colors = geometry.attributes.color.array;

    // TODO: For some reason, incrementing loop by 3 doesn't work. Need to do by 4 for glTF.
    colorHelper.set(data.baseColor);
    for (i = 0; i < colors.length; i += data.itemSize) {
      colors[i] = colorHelper.r;
      colors[i + 1] = colorHelper.g;
      colors[i + 2] = colorHelper.b;
    }

    geometry.attributes.color.needsUpdate = true;
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['vertex-colors-buffer',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
